import COLORS from './colors';

const pagination = {
  styleOverrides: {
    root: {
      '& .MuiPagination-ul': {
        '& .MuiButtonBase-root': {
          fontSize: 14,
          minWidth: 29,
          height: 29,
          margin: '0 2px',

          '&:hover': {
            backgroundColor: 'transparent',
            color: COLORS.gray
          }
        },

        '& .MuiPaginationItem-previousNext , & .MuiPaginationItem-firstLast': {
          borderColor: COLORS.gray,
          minWidth: 32,
          height: 32,
          color: COLORS.gray,
          transition: 'all .3s ease',

          '&:hover': {
            borderColor: COLORS.borderColor,
            color: COLORS.textSecondColor
          }
        },
        '& .MuiPaginationItem-page': {
          borderColor: 'transparent'
        },
        '& .Mui-selected': {
          backgroundColor: 'transparent',
          color: COLORS.accent,
          fontWeight: 500
        }
      }
    }
  }
};

export default pagination;
